import React from 'react';
import moment from 'moment';
import { Icon } from 'semantic-ui-react';

import { get, isEmpty } from '../../utils/lodash';
import { threeDotSeparator } from '../../utils';

// TODO:i18n-date - date formatting is locale dependent!!
function formatDateRange(eventStartDate, eventEndDate) {
  if (!eventStartDate) return null;
  const start = moment(eventStartDate);
  const end = eventEndDate ? moment(eventEndDate) : null;
  if (!end || start.isSame(end, 'day')) {
    return start.format('D MMM YYYY');
  }
  return `${start.format('D MMM')} – ${end.format('D MMM YYYY')}`;
}

function getSuburbs(venues) {
  if (isEmpty(venues)) return null;
  const suburbs = venues
    .map((v) => get(v, 'venueDetail.suburb'))
    .filter(Boolean);
  return isEmpty(suburbs) ? null : [...new Set(suburbs)].join(', ');
}

function LinkedActivityRow({ linkedActivity, isSelected, onSelect }) {
  if (!linkedActivity.visible) {
    return (
      <div className="lib-card__linked-row lib-card__linked-row--disabled">
        <Icon name="lock" />
        <span className="lib-card__linked-name">{linkedActivity.name}</span>
      </div>
    );
  }

  const dateRange = formatDateRange(
    linkedActivity.eventStartDate,
    linkedActivity.eventEndDate
  );

  return (
    <div
      className={`lib-card__linked-row${
        isSelected ? ' lib-card__linked-row--selected' : ''
      }`}
      onClick={(e) => {
        e.stopPropagation();
        onSelect(linkedActivity.id);
      }}
    >
      <Icon name="angle right" />
      <span className="lib-card__linked-name">{linkedActivity.name}</span>
      {dateRange && <span className="lib-card__linked-date">{dateRange}</span>}
    </div>
  );
}

function LibraryCard({ activity, selectedActivityId, onSelect }) {
  const isSelected = activity.id === selectedActivityId;
  const dateRange = formatDateRange(
    activity.eventStartDate,
    activity.eventEndDate
  );
  const suburbs = getSuburbs(activity.venues);
  const eventDetail = get(activity, 'eventDetail.detail', null);
  const linkedActivities = activity.linkedActivities || [];

  return (
    <div
      className={`lib-card${isSelected ? ' lib-card--selected' : ''}`}
      onClick={() => onSelect(activity.id)}
    >
      <div className="lib-card__header">
        <span className="lib-card__name">{activity.name || ''}</span>
      </div>
      <div className="lib-card__meta">
        {dateRange && (
          <span className="lib-card__meta-item">
            <Icon name="calendar alternate outline" />
            {dateRange}
          </span>
        )}
        {eventDetail && (
          <span className="lib-card__meta-item">
            <Icon name="tag" />
            {eventDetail}
          </span>
        )}
        {suburbs && (
          <span className="lib-card__meta-item">
            <Icon name="map marker alternate" />
            {suburbs}
          </span>
        )}
      </div>
      {activity.description && (
        <div className="lib-card__summary">
          {threeDotSeparator({
            name: activity.description,
            length: 160,
            isPopUp: false,
          })}
        </div>
      )}
      {!isEmpty(linkedActivities) && (
        <div className="lib-card__linked">
          {linkedActivities.map((linkedActivity) => (
            <LinkedActivityRow
              key={linkedActivity.id}
              linkedActivity={linkedActivity}
              isSelected={linkedActivity.id === selectedActivityId}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export { LibraryCard };
